import axios, { AxiosInstance } from "axios";
import { Storage } from "@ionic/storage";

const axiosInstance: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_ADDR,
  headers: {
    //common: {
      //"Ocp-Apim-Subscription-Key": "cd4ed8b372ef47189706abe7ae615788",
    //},
  },
  timeout: 10000,
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    let originalConfig = error.config;

    if (error.request.status === 401 && !originalConfig._retry) {
      originalConfig._retry = true;
      try {
        const response = await axiosInstance.post("/Users/refresh-token");
        // console.log(response.data);

        const storage = new Storage();
        await storage.create();
        await storage.set("token", response.data.jwtToken);

        // Reload the page or handle the token refresh manually
      } catch (error) {
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
